export default "__VITE_ASSET__c7e2fe69__"